import { QBAssetListCardIconBarProps } from '../QBAssetListCardIconBar/types'
import { QBAssetListCardChaptersContentProps } from './types'
import { styles } from './styles'
import { FText, FUseColor } from '@fantaskticedtechlimited/fui-complib'
import { FFontTypes } from '@fantaskticedtechlimited/fui-fontlib'
import QBAssetListCardIconBar from '../QBAssetListCardIconBar'

export const QBAssetListCardChaptersContent = (
    props: QBAssetListCardChaptersContentProps
) => {
    const data = props.data
    const chapterData = data.questionTypes
    const iconBarProps: Partial<QBAssetListCardIconBarProps> = {
        questionTypeNumber: chapterData.length,
        questionGroupsNumber: chapterData.reduce(
            (total, currentType) =>
                (total = total + currentType.questionGroups.length),
            0
        ),
    }

    return (
        <div className={styles.CardContent_Container} onClick={props.onClick}>
            <FText
                font={FFontTypes.Large_Text()}
                color={FUseColor({ colorName: 'Grey' })}
            >
                {data.orderSequence}
            </FText>
            <FText
                font={FFontTypes.Large_Text()}
                maxRows={2}
                overflowHidden
                style={{ flex: 1 }}
            >
                {data.name}
            </FText>
            <QBAssetListCardIconBar {...iconBarProps} />
        </div>
    )
}
